/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-download': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.513 5.59l-.031-4.184-.01-.09a.5.5 0 0 0-.99.097l.031 4.159-1.385-1.23a.5.5 0 0 0-.726.682l.062.065 2.24 1.992a.5.5 0 0 0 .596.051l.075-.057 2.168-1.991a.5.5 0 0 0-.605-.791l-.072.054L5.513 5.59zm4.02.41c.229 0 .42.162.46.376l.007.082v3.084a.461.461 0 0 1-.384.45L9.532 10H.468a.465.465 0 0 1-.46-.376L0 9.542V6.458C0 6.205.21 6 .468 6c.23 0 .42.162.46.376l.007.082v2.625h8.13V6.458c0-.225.165-.412.383-.45L9.532 6z" _fill="#fff"/>'
  }
})
